import React, { createContext, useState, useCallback, useContext, useEffect } from 'react'

import Title from '@models/Title'

import { ClassProperties } from '../types/utils'

export interface TitleContextType {
  title: Title
  updateTitle: (data: Partial<ClassProperties<Title>>) => void
}

export const TitleContext = createContext<TitleContextType>({
  title: {} as Title,
  updateTitle: () => null,
})

interface Props {
  title: Title
}

const TitleProvider: React.FC<Props> = ({ children, title }) => {
  const [titleState, setTitle] = useState<Title>(title)

  // Update title state if title prop changes
  useEffect(() => {
    if (title !== titleState) {
      setTitle(title)
    }
  }, [title, titleState])

  const contextValue: TitleContextType = {
    title: titleState,
    updateTitle: useCallback((props) => {
      setTitle((prevTitle) => {
        for (const key of Object.keys(props)) prevTitle[key] = props[key]
        return new Title(prevTitle)
      })
    }, []),
  }

  return <TitleContext.Provider value={contextValue}>{children}</TitleContext.Provider>
}

export default TitleProvider

export const useTitle = () => useContext(TitleContext)
